import { FC } from 'react';

export const Upload: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L16.7071 7.29287C17.0976 7.68339 17.0976 8.31655 16.7071 8.70708C16.3166 9.09761 15.6834 9.09761 15.2929 8.70708L13 6.4142V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V6.4142L8.7071 8.70708C8.31658 9.09761 7.68341 9.09761 7.29289 8.70708C6.90237 8.31656 6.90237 7.68339 7.2929 7.29287L11.2929 3.29289ZM4 15C4.55228 15 5 15.4477 5 16V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16V18C21 19.6568 19.6569 21 18 21H6C4.34315 21 3 19.6568 3 18V16C3 15.4477 3.44772 15 4 15Z"
			fill="currentColor"
		/>
	</svg>
);
